import React, { Component } from "react";
import authService from "../services/authService";
import { Link } from "react-router-dom";
import myStatusService from "../services/myStatusService";
import ViewModeAlert from "../components/viewModeAlert";

class ethics extends Component {
  _isMounted = false;

  state = {
    subPaths: [
      {
        course: "ki_and_society",
        title: "KI & Gesellschaft",
        description:
          "Hier findest du eine Vielzahl an Artikeln zu verschiedenen Themen, in denen KI Anwendung in unserem gesellschaftlichen Leben findet.",
        subHeader: "Trainiere kritisches Denken",
        link: "/ethics/course=ki_and_society",
        image: "aiSociety.svg",
      },
      {
        course: "ethics",
        title: "Ethisch fragwürdig",
        description:
          "Hier lernst du KI-Anwendungen zu hinterfragen und diskutierst mit deiner eigenen Arbeitsgruppe Vorteile und Nachteile.",
        subHeader: "Diskutiere KI-Anwendungen",
        link: "/ethics/ethically-questionable/intro-video",
        image: "Wie_ethisch_fragwürdig.svg",
      },
      {
        course: "air",
        title: "KI-Regulierungen",
        description:
          "In diesem Kapitel könnt ihr erfahren, wie KI-Anwendungen gesetzlich reguliert werden sollen und welche Strategien dabei verfolgt werden.",
        subHeader: "Rechtlicher Rahmen",
        link: "/ethics/ai-regulations/page=1",
        image: "Icon_Regulierungen_old_scheme.svg",
      },
    ],
    viewMode: true,
    // Keyed by module key: { [module]: { total_tasks, attempted_tasks } }.
    // Filled from /my-status; empty until the request resolves.
    taskCounts: {},
    showViewModeMessage: false,
  };

  componentDidMount() {
    this._isMounted = true;

    let user = authService.getCurrentUser();
    if (!user) {
      this.setState({
        viewMode: true,
      });
      return;
    }

    this.setState({ viewMode: false });

    myStatusService
      .getTaskCountsByModule()
      .then((taskCounts) => {
        if (!this._isMounted) return;
        this.setState({ taskCounts });
      })
      .catch(() => {
        // Leave taskCounts empty: the progress line stays hidden
        // rather than showing a possibly stale number.
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  removeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  onRegister = () => {
    this.props.history.push({
      pathname: "/auth",
      state: { prevPath: this.props.location.pathname },
    });
    this.setState({ showViewModeMessage: false });
  };

  toggleViewModeMessage = () => {
    this.setState({ showViewModeMessage: !this.state.showViewModeMessage });
  };

  render() {
    const { taskCounts } = this.state;
    const user = authService.getCurrentUser();
    let viewMode = true;
    // if (!user && viewMode) this.props.history.push('/auth')

    // let course = this.props.match.params;
    if (user) viewMode = false;

    // The user must be logged in, which it is here.
    const renderStatusContent = (subPath) => {
      const counts = taskCounts[subPath.course];
      if (!counts || !counts.total_tasks) return null;
      return `${counts.attempted_tasks} / ${counts.total_tasks} Aufgaben bearbeitet`;
    };

    return (
      <React.Fragment>
        <section className="content">
          <div className="container-fluid home-wrapper">
            <div className="subpath-tiles">
              {this.state.subPaths.length > 0 &&
                this.state.subPaths.map((subPath) => (
                  <Link
                    to={`${subPath.link}`}
                    className="subpath-tile"
                    key={subPath.course}
                  >
                    <div className="tile-wrapper">
                      <img
                        className="image negative-margin"
                        src={`/images/icons/subpaths/ethics/${subPath.image}`}
                      />
                      <div className="row2 primary-color-lightgreen-background">
                        <div className="tile-sub-header">
                          {subPath.subHeader}
                        </div>
                        <div className="tile-header">{subPath.title}</div>
                        <div className="tile-description">
                          {subPath.description}
                        </div>
                        {!viewMode && (
                          <div className="tile-status">
                            {renderStatusContent(subPath)}
                          </div>
                        )}
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
          {this.state.showViewModeMessage && (
            <ViewModeAlert
              onRegister={this.onRegister}
              onCancel={this.toggleViewModeMessage}
            />
          )}
        </section>
      </React.Fragment>
    );
  }
}

export default ethics;
